import React, { useCallback } from 'react'

import { string } from 'prop-types'

import CheckoutInfoCard from 'Pods/Shared/CheckoutInfoCard/CheckoutInfoCard'
import I18n from 'Pods/Shared/I18n'

const SUPPORT_EMAIL = 'support@cgtrader.com'

function ExtraUsageTerms({ locale = 'en' }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  return (
    <CheckoutInfoCard title={translate('extra_usage_checkout.terms.title')}>
      <p>{translate('extra_usage_checkout.terms.body')}</p>
      <p>
        {translate('extra_usage_checkout.terms.support_prefix')}{' '}
        <a className="cgt-link-primary-accented" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
        .
      </p>
    </CheckoutInfoCard>
  )
}

ExtraUsageTerms.propTypes = {
  locale: string,
}

export default ExtraUsageTerms
